<template>
  <div v-if="banners.length" class="lg:py-10 py-8">
    <h2 class="beta container">
      Brändit
    </h2>
    <div class="md:container">
      <div class="overflow-x-auto md:overflow-visible">
        <div class="flex md:grid md:grid-cols-6 grid-cols-2 gap-2 md:gap-4">
          <component
            :is="linkConfig(banner).element"
            v-for="(banner, i) in banners"
            :key="i"
            v-bind="linkConfig(banner).attrs"
            class="flex-shrink-0 w-2/5 md:w-full mt-2"
          >
            <picture v-if="banner.image?.url">
              <img
                :src="lexasImage(banner.image.url, 200)"
                :srcset="lexasImage(banner.image.url, 400) + ' 2x'"
                :alt="banner.image.altText || 'Brändikuva'"
                width="200"
                height="100"
                loading="lazy"
              >
            </picture>
          </component>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { lexasImage } from '~/helpers/lexasImage'
import { useLexas } from '~/composables/useLexas'
import type { BrandListItem } from '~/types/lexas/brandList.ts'

const { getBrandList } = useLexas()
// Fetch brand banners
const banners = await getBrandList()

// Check if the link is external
const isExternal = (link: string) => /^(http|https):\/\//.test(link)
const NuxtLink = resolveComponent('NuxtLink')

const linkConfig = computed(() => (banner: BrandListItem) => {
  const link = banner.link
  return link
    ? isExternal(link)
      // If the link is external, return an anchor element
      ? { element: 'a', attrs: { href: link, target: '_blank', rel: 'noopener noreferrer' } }
      // If the link is internal, return NuxtLink
      : { element: NuxtLink, attrs: { to: link } }
    // If there's no link, return a div element
    : { element: 'div', attrs: {} }
})
</script>
